import { IStateErrorBase, IStateSuccessBase } from '@boxx/core';

// --------------------- CATEGORIES: --------------------------
export type StoreCategoriesStateType =
  | 'LOAD_CATEGORIES'
  | 'CREATE_CATEGORY'
  | 'UPDATE_CATEGORY'
  | 'DELETE_CATEGORY'
  | 'UPLOAD_IMAGE_CATEGORY'
  | 'CATEGORY_IMAGE_UPLOADED'
  | 'GET_SINGLE_CATEGORY'
  | 'DELETE_IMAGE_CATEGORY'
  | 'UNKNOWN';

export interface IStoreCategoriesStateError extends IStateErrorBase {
  after: StoreCategoriesStateType;
}

export interface IStoreCategoriesStateSuccess extends IStateSuccessBase {
  after: StoreCategoriesStateType;
}

// --------------------- ORDERS: --------------------------
export type StoreOrdersStateType = 'LOAD_ORDERS' | 'UPDATE_ORDER' | 'UNKNOWN';

export interface IStoreOrdersStateError extends IStateErrorBase {
  after: StoreOrdersStateType;
}

export interface IStoreOrdersStateSuccess extends IStateSuccessBase {
  after: StoreOrdersStateType;
}

// --------------------- PRODUCTS: --------------------------
export type StoreProductsStateType =
  | 'LOAD_PRODUCTS'
  | 'CREATE_PRODUCT'
  | 'UPDATE_PRODUCT'
  | 'DELETE_PRODUCT'
  | 'GET_SINGLE_PRODUCT'
  | 'DELETE_IMAGE_PRODUCT'
  | 'GET_UPDATED_PRODUCT'
  | 'UNKNOWN';

export interface IStoreProductsStateError extends IStateErrorBase {
  after: StoreProductsStateType;
}

export interface IStoreProductsStateSuccess extends IStateSuccessBase {
  after: StoreProductsStateType;
}

// --------------------- VARIATIONS: --------------------------
export type StoreVariationsStateType =
  | 'LOAD_VARIATIONS'
  | 'CREATE_VARIATION'
  | 'DELETE_VARIATION'
  | 'UNKNOWN';

export interface IStoreVariationsStateError extends IStateErrorBase {
  after: StoreVariationsStateType;
}

export interface IStoreVariationsStateSuccess extends IStateSuccessBase {
  after: StoreVariationsStateType;
}

// --------------------- IMAGES: --------------------------
export type StoreImagesStateType =
  | 'LOAD_IMAGES'
  | 'CREATE_IMAGE'
  | 'DELETE_IMAGE'
  | 'UNKNOWN';

export interface IStoreImagesStateError extends IStateErrorBase {
  after: StoreImagesStateType;
}

export interface IStoreImagesStateSuccess extends IStateSuccessBase {
  after: StoreImagesStateType;
}

// --------------------- ECWID: --------------------------
export type StoreEcwidStateType =
  | 'LOAD_URL'
  | 'CREATE_URL'
  | 'DELETE_URL'
  | 'UNKNOWN';

export interface IStoreEcwidStateError extends IStateErrorBase {
  after: StoreEcwidStateType;
}

export interface IStoreEcwidStateSuccess extends IStateSuccessBase {
  after: StoreEcwidStateType;
}

// --------------------- PROFILE STORE  : --------------------------
export type StoreProfileStateType = 'LOAD_PROFILE' | 'UPDATE_PROFILE' | 'UPDATE_PROFILE_IMAGE' | 'DELETE_PROFILE_IMAGE' | 'UNKNOWN';

export interface IStoreProfileStateError extends IStateErrorBase {
  after: StoreProfileStateType;
}

export interface IStoreProfileStateSuccess extends IStateSuccessBase {
  after: StoreProfileStateType;
}


// --------------------- COUPON STORE  : --------------------------
export type StoreCouponsStateType = 'LOAD_COUPONS' | 'CREATE_COUPON' | 'UPDATE_COUPON' | 'GET_SINGLE_COUPON' | 'DELETE_COUPON' | 'UNKNOWN';

export interface IStoreCouponsStateError extends IStateErrorBase {
  after: StoreCouponsStateType;
}

export interface IStoreCouponsStateSuccess extends IStateSuccessBase {
  after: StoreCouponsStateType;
}

